// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"6ab10529","667":"65b8e0fe","977":"4eeb4cd4"}[chunkId] + ".chunk.js";
};